<template>
    <v-layout>
        <div class="emptyNotify" v-if="lstClass.length == 0">
            <v-layout wrap>
                <v-flex xs12 sm12 md6 lg6 xl6>
                    <img class="responsive_image" src="../../../public/p6/images/anh-p6.png" width="400px" style="float: left"/>
                </v-flex>
                <v-flex xs12 sm12 md6 lg6 xl6>
                    <div v-if="$store.state.auth.user.role==1"
                         v-html="$t('lang.class.empty_class_admin_teacher')"></div>
                    <div v-if="$store.state.auth.user.role==2" v-html="$t('lang.class.empty_class_student')"></div>
                    <br/>
                    <v-btn class="yoprimary" dark @click="createClass"
                           v-if="$store.state.auth.user.role==1 || $store.state.auth.user.role==4">
                        {{$t('lang.class.createClass')}}
                    </v-btn>
                    <v-btn class="yoprimary" dark @click="joinClass" v-if="$store.state.auth.user.role==2">
                        {{$t('lang.class.joinClass')}}
                    </v-btn>
                </v-flex>
            </v-layout>
        </div>
        <div class="hotClass" style="background-color: white; padding: 10px 20px" v-else>
            <v-btn flat class="yoprimary" dark round @click="createClass"
                   v-if="$store.state.auth.user.role==1|| $store.state.auth.user.role==4">
                <v-icon>add</v-icon>
                {{$t('lang.class.createClass')}}
            </v-btn>
            <v-btn flat class="yoprimary" dark round @click="joinClass" v-if="$store.state.auth.user.role==2">
                <v-icon>add</v-icon>
                {{$t('lang.class.joinClass')}}
            </v-btn>
            <!--div class="class" @click="createClass">
                <v-icon dark color="primary" fab style="font-size: 105px">add</v-icon>
                <div class="classTitle">{{$t('lang.class.createClass')}}</div>
            </div-->
            <table class="classTable">
                <tr>
                    <td colspan="4" style="font-weight: bold">
                        Lớp học của bạn
                    </td>
                </tr>
                <tr v-for="cl in lstClass">
                    <td width="15%" style="vertical-align: middle;text-align: center" valign="middle"><img
                            :src="getClassAvatar(cl.avatarId)"
                            style="width:60px;height: 60px;border-radius: 60px;border:1px dashed green"/>
                    </td>
                    <td width="50%">
                        <div>
                            <div style="font-weight: bold">{{cl.className}}</div>
                            <div>{{cl.classBlockName}}-{{cl.disciplineName}}</div>
                            <div v-if="$store.state.auth.user.role!=1">Trường trung tâm: {{cl.schoolName}}</div>
                            <div style="font-style: italic">Ngày tạo: {{cl.createAt | formatDate}}</div>
                        </div>
                    </td>
                    <td width="20%">
                        <div class="clazzInfo"><label v-if="cl.numberOfStudent>0">{{cl.numberOfStudent}}</label>
                            {{$t('lang.class.student')}}
                        </div>
                    </td>
                    <td width="15%">
                        <v-btn dark flat round style="background-color: #00ab4d" @click="viewClass(cl)"
                               v-if="cl.status == 1">Vào lớp
                        </v-btn>
                        <v-btn dark flat round style="background-color: orange" v-else>Chờ duyệt</v-btn>
                    </td>
                </tr>
            </table>
        </div>
    </v-layout>
</template>

<script>
    import {message} from '../../services';
    import axios from "axios";
    import ClazzCreate from "../class/createClass";

    export default {
        name: 'my-class-component',
        components: {ClazzCreate},
        data() {
            return {
                lstClass: [],
                search: null
            }
        },
        created() {
            this.unsubscribe = this.$store.subscribe((mutation, state) => {
                if (mutation.type == "common/setSearch") {
                    this.search = mutation.payload;
                    this.searchClass();
                }
            });
            this.searchClass();

        },
        beforeDestroy() {
            this.unsubscribe();
        },
        methods: {
            joinClass: function () {
                this.$router.push("/joinClass");
            },

            searchClass: function () {
                let url = process.env.VUE_APP_API_URL + "/class/myclass?";
                if (this.search != null && this.search != "") {
                    url += "search=" + this.search;
                }
                axios.post(url).then(
                    data => {
                        this.lstClass = data;
                    },
                    error => {
                        //console.log(error);
                    }
                )
            },

            getClassAvatar: function (attachId) {
                let link = "/img/yoclass/logo_green.png";
                if (attachId == null || attachId == "" || attachId == undefined) {

                } else {
                    link = process.env.VUE_APP_API_URL + "/download/attach/" + attachId;
                }
                return link;

            },

            viewClass: function (clss) {
                if (clss.status == 0) {
                    message.error("Bạn chưa được phê duyệt vào lớp");
                } else {
                    this.$router.push("ViewClass/" + clss.classId);
                }
            },

            createClass: function () {
                if (this.$store.state.auth.user.role == 4) {
                    message.error("Chức năng chỉ dành cho giáo viên admin");
                } else if (this.$store.state.auth.user.role == 1) {
                    this.$router.push("/CreateClass");
                }
            }
        }
    };
</script>